import React, {useContext} from 'react';
import {useTranslation} from "react-i18next";
import SidebarNavigationButton from "../../../components/SidebarNavigationButton/SidebarNavigationButton";
import {useAppSelector} from "../../../../../../app/store";
import {selectCurrentUser} from "../../../../../../features/authentication/authenticationSliceSelectors";
import {UserRole} from "../../../../../../app/enums/UserRole";
import {getUserRole} from "../../../../../../helpers/user";
import SidebarNavigationNestedButton
    from "../../../components/SidebarNavigationButton/SidebarNavigationNestedButton/SidebarNavigationNestedButton";
import {SidebarContext} from "../../../Sidebar";
import {isMobile} from "react-device-detect";

type SidebarMenuCustomerBillingProps = {
    expandedId: string;
    onClick?: (id: string) => void;
};

const SidebarMenuCustomerBilling: React.FC<SidebarMenuCustomerBillingProps> = ({
                                                                  expandedId,
                                                                  onClick: onClickProp,
                                                              }) => {
    const {t} = useTranslation();
    const user = useAppSelector(selectCurrentUser);

    const {
        expanded,
        hoverExpanded,
        setIsExpandedOnHover
    } = useContext(SidebarContext);

    const handleNavigationClick = (id: string) => {
        if (onClickProp) {
            onClickProp(id);
        }
    };

    const handleNestedNavigationClick = () => {
        if (isMobile && !expanded && hoverExpanded) {
            setIsExpandedOnHover(false);
        }
    }

    if (!user) {
        return null;
    }

    let role = getUserRole(user);

    if (role !== UserRole.Administrator &&
        role !== UserRole.Forwarder) {
        return null;
    }

    return (
        <SidebarNavigationButton id={'sidebar-customer-billing'}
                                expandedId={expandedId}
                                 type={'primary'}
                                 onClick={handleNavigationClick}
                                 text={t("sidebar.customer-billing.main-page")}
                                 title={t("sidebar.customer-billing.main-page")}
                                 path={'/customerBilling'}
                                 icon={"faCubeApproved"}
                                 >
            <SidebarNavigationNestedButton id={'sidebar-customer-billing-item-in-progress'}
                                           type={'primary'}
                                           path={'/customerBilling/in-progress'}
                                           text={t("sidebar.customer-billing.in-progress")}
                                           title={t("sidebar.customer-billing.in-progress")}
                                           tooltip={t("sidebar.customer-billing.in-progress-tooltip") || ''}
                                           onClick={handleNestedNavigationClick}
            />
            <SidebarNavigationNestedButton id={'sidebar-customer-billing-item-closed'}
                                           type={'primary'}
                                           path={'/customerBilling/closed'}
                                           text={t("sidebar.customer-billing.closed")}
                                           title={t("sidebar.customer-billing.closed")}
                                           tooltip={t("sidebar.customer-billing.closed-tooltip") || ''}
                                           onClick={handleNestedNavigationClick}
            />
        </SidebarNavigationButton>
    );
};

export default SidebarMenuCustomerBilling;
